<template>
<div class="s4s-page">
  <div v-if="RemindInfo1" class="remind_info">{{RemindInfo1}}</div>
  <div :class="orderhead">
    <div>处罚决定书</div>
    <div v-if="form_warning">
      <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png" mode="widthFix" class="order-waring" />
      <span class="yellow">请完善罚单信息</span>
    </div>
    <div v-if="form_error">
      <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png" mode="widthFix" class="order-waring" />
      <span class="red">{{checkData.msg}}</span>
    </div>
  </div>
  <div class="s4s-pay-body">
      <div class="s4s-group group-image" style="border: 0;">
        <div class="s4s-group-tit">处罚决定书</div>
        <div style="display: flex;">
          <img
            :src="imageUrl||require('../assets/icon/uplaod3.png')"
            class="order-image-ticket"
            style="background:#eee;"
            mode="aspectFill"
            @click="handleCheckTicket();showProvice = false" />
            <div :class="showTicket ? 'ticket-container-show ticket-container':'ticket-container'" @click="handleHideTicket">
              <div catchTap="doNothing">
                <img :src="imageUrl" mode="widthFix" class="ticket-container-image" />
              </div>
              <div class="ticket-btn-container">
                <div class="ticket-btn" v-if="showTicket" @click="chooseImage('ticket')">
                  <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_reupload.png" mode="widthFix" class="ticket-btn-reupload" />
                  重新上传
                </div>
                <div class="ticket-btn" v-if="showTicket" @click="handleHideTicket">
                  <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/close.png" mode="widthFix" class="ticket-btn-reupload" />
                  关闭
                </div>
              </div>
            </div>
          <canvas id="canvas" style="display: none;"></canvas>
          <input type="file" accept="image/*" @change="uploader"
          ref="file" id="file" style="display: none;">
        </div>
      </div>
      <div class="write-tip">如有信息录入错误，可点击修改信息</div>
      <div :class="ticket_image?'s4s-group group-image': 's4s-group'">
        <div class="s4s-group-tit">处罚编号
          <img :src="noticeNum===''?
            'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png'
            :checkData.ticket?'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png'
            :'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_suc.png'" mode="widthFix" class="order-waring" />
        </div>
        <div class="s4s-group-txt">
          <img v-if="ticket_image" :src="ticket_image" mode="aspectFit" class="order-image-other" />
          <input style="text-align:right" v-model="noticeNum" focus="bindFocus" maxlength="16" placeholder-style="color:#9c9ea8;" placeholder="请输入15-16位处罚决定书编号" />
        </div>
      </div>
      <div :class="vio_time_image?'s4s-group group-image': 's4s-group'"
        style="justify-content: space-between;">
          <div class="s4s-group-tit">认罚日期
            <img :src="date===''?
            'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png'
            :checkData.date?'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png'
            :'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_suc.png'" mode="widthFix" class="order-waring" />
            </div>
          <div class="s4s-group-txt" @click="$refs.picker.show();showProvice = false;">
            <img v-if="vio_time_image" :src="vio_time_image" mode="aspectFit" class="order-image-other" />
            <span v-if="date">
              {{date}}
            </span>
            <span  class="less-grey" v-else >
              请选择认罚日期
            <img src="../assets/icon/arrow_bottom.png" class="s4s-arr-bottom"/>
            </span>
          </div>
          <!-- 时间选择器 start -->
          <awesome-picker
            ref="picker"
            :type="picker.type"
            :data="picker.data"
            :anchor="picker.anchor"
            :textTitle="picker.textTitle"
            :textConfirm="picker.textConfirm"
            :textCancel="picker.textCancel"
            :swipeTime="picker.swipeTime"
            :colorTitle="picker.colorTitle"
            :colorConfirm="picker.colorConfirm"
            :colorCancel="picker.colorCancel"
            @cancel="handlePickerCancel"
            @confirm="handlePickerConfirm">
          </awesome-picker>
          <!-- 时间选择器 end -->
      </div>
      <div :class="fine_image?'s4s-group group-image': 's4s-group'">
          <div class="s4s-group-tit">罚款金额
            <img :src="price===''?
            'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png'
            :checkData.price?'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png'
            :'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_suc.png'" mode="widthFix" class="order-waring" />
          </div>
          <div class="s4s-group-txt">
            <img v-if="fine_image" :src="fine_image" mode="aspectFit" class="order-image-other" />
            <input type="number" placeholder-style="color:#9c9ea8;" placeholder="最低金额至少为20元"  @focus="showProvice = false" v-model="price" maxlength="6"/>
          </div>
      </div>
      <div :class="carno_image?'s4s-group group-image': 's4s-group'" v-if="isCarNoRequire">
          <div class="s4s-group-tit">车牌号码
            <img :src="carno===''?
            'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png'
            :checkData.carno?'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png'
            :'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_suc.png'" mode="widthFix" class="order-waring" />
          </div>
          <div class="s4s-group-txt">
            <img v-if="carno_image" :src="carno_image" mode="aspectFit" class="order-image-other" />
            <div style="display: flex;align-items:center;overflow: hidden;justify-content: flex-end;">
                <div class="s4s-sel-provice" style="margin-right:0" @click="showProvice = !showProvice">
                    <span>{{ provice }}</span>
                    <div class="triangle-button"></div>
                </div>
                <input type="text" name="carno" maxlength="7"
                  v-model="carno" placeholder="请输入车牌号码"
                  style="text-transform:uppercase;" @focus="showProvice = false"/>
            </div>
          </div>
      </div>
      <div :class="name_image?'s4s-group group-image': 's4s-group'">
          <div class="s4s-group-tit">被处罚人
            <img :src="nick===''?
            'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png'
            :checkData.nick?'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png'
            :'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_suc.png'" mode="widthFix" class="order-waring" />
          </div>
          <div class="s4s-group-txt">
            <img v-if="name_image" :src="name_image" mode="aspectFit" class="order-image-other" />
            <input type="text" maxlength="20"
            @focus="showProvice = false" placeholder="请输入中文姓名"  v-model="nick"/>
          </div>
      </div>
      <div class="s4s-group" >
        <div class="s4s-group-tit">手机号码
          <img :src="phone===''?
            'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png'
            :checkData.phone?'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_waring.png'
            :'https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_suc.png'" mode="widthFix" class="order-waring" />
        </div>
        <div class="s4s-group-txt">
          <input
            @focus="showProvice = false"
            v-model="phone"
            type="text"
            maxlength="11"
            placeholder="请输入手机号码"/>
        </div>
      </div>
      <!-- <div :class="isNoticeFileTrue
        ? 's4s-group group-upload'
        : 's4s-group group-upload s4s-group-error'"
        style="height:auto">
        <div class="s4s-group-tit">上传罚单</div>
        <div style="flex:1;display: flex;">
          <img
            :src="imageUrl||require('../assets/icon/uplaod3.png')"
            style="background:#eee;width:90px;height:70px;"
            mode="scaleToFill"
            @click="chooseImage('ticket');showProvice = false" />
            <canvas id="canvas" style="display: none;"></canvas>
          <input type="file" accept="image/*" @change="uploader"
          ref="file" style="display: none;">

        </div>
        <div
          class="s4s-help"
          @click="showImage('https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/ticketFile.png')"></div>
      </div>
      <div class="s4s-mask" bind:tap="closeMake" v-if="showTicket">
        <img :src="src" class="s4s-mask-image" mode="aspectFit" />
      </div> -->
  </div>
      <div class="ticket-attention" v-if="RemindInfo2.length>0">
        <div v-if="RemindInfo2[0]"><text class="blue-point"></text>{{RemindInfo2[0]}}</div>
        <div v-if="RemindInfo2[1]"><text class="blue-point"></text>{{RemindInfo2[1]}}</div>
        <div v-if="RemindInfo2[2]"><text class="blue-point"></text>{{RemindInfo2[2]}}</div>
      </div>
      <div v-if="error" class="s4s-error">{{error}}</div>
      <div class="attention-important" v-if="XcdNotice"
      style="margin-top:10px;" @click="handleShowNotice">
          <img src="../assets/icon/notice_icon.png"
          style="width:14px;height:14px;margin-right:5px;"/>
          {{XcdNotice.Title}}
          <img src="../assets/icon/notice_icon_right.png"
          style="width:8px;height:12px;margin-left:10px;"/>
      </div>
      <div class="s4s-pay-body" :style="XcdNotice?'':'margin-top:10px;'">
        <div class="s4s-group s4s-fee" v-if="Quick">
          <div class="s4s-group-tit"
              style="width:auto;flex: 1;">
            2小时加急
            <span class="s4s-help" @click="feeQues"></span>
          </div>
          <span
              class="s4s-group-txt"
              style="text-align:right;">
              <span
                :class="openQuick?'weui-switch-on weui-switch' : 'weui-switch'"
                @click="openQuick=!openQuick"/>
            </span>
          <!-- <switch name="switch1" type="switch" bindchange="changeFee"></switch> -->
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">罚款金额</span>
          <span class="s4s-group-txt">￥{{Number(price).toFixed(2) || '0.00'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">滞纳金额</span>
          <span class="s4s-group-txt">
            ￥{{ ShowLateFree || '0.00' }}
            <span style="color:#9c9ea8;">(由系统自动计算)</span>
          </span>
        </div>
        <!-- <div class="s4s-group">
          <span class="s4s-group-tit">滞纳金额</span>
          <span class="s4s-group-txt">￥{{Number(lateFree).toFixed(2) || '0.00'}}</span>
        </div> -->
        <div class="s4s-group">
          <div class="s4s-group-tit">服务费用
            <span class="s4s-help" @click="ownFreeModal"></span>
          </div>
          <span class="s4s-group-txt" style="color:#FFAF30;">
            ￥{{ Number(ownFree).toFixed(2) || '0.00'}}
          </span>
        </div>
        <div class="s4s-group" v-if="openQuick">
          <span class="s4s-group-tit">加急费用</span>
          <span class="s4s-group-txt">
            ￥{{ Number(QFee).toFixed(2) || '0.00'}}
          </span>
        </div>
        <!-- <div v-if="useCoupon" class="s4s-group" >
          <div class="s4s-group-tit"><div class="s4s-group-coupon-icon" >惠</div> 立减券</div>
          <span class="s4s-group-txt"  style="color:#FD2900;" >- ￥{{ couponPrice }}</span>
        </div> -->
        <div class="s4s-group" style="justify-content: space-between;" @click="gotoCoupon" v-if="price&&date">
          <span class="s4s-group-tit">优惠券</span>
          <span v-if="useCoupon" class="s4s-group-txt" style="color:#FD2900;">- ￥{{ ((couponFee || 0) / 100).toFixed(2) }}</span>
          <span v-else :class="couponLen > 0 ? ' flex red':' flex'" >您有{{couponLen}}张可使用优惠券<img src="../assets/icon/right_arr.png" mode="aspectFit" class="s4s-right-arr"/></span>
        </div>
      </div>
      <div class="s4s-pay">
        <div class="s4s-pay-container">
          <div class="s4s-pay-btn" >
              <div class="s4s-pay-text">合计金额：
                <span  style="color:#FD2900;font-weight: bold;">
                  ￥ {{
                    (Number(ShowTotalPrice) + (Quick&&openQuick?Number(QFee):0)).toFixed(2)
                    || '0.00'
                    }}
                </span>
              </div>
              <div class="s4s-pay-tip">预计{{openQuick?'2小时内':'24小时内'}}办理完成 </div>
          </div>
          <div v-if="!payloading" class="s4s-pay-btn" @click="formSubmit" :style="{backgroundImage:advertisingShow.backgroundImage}">
            立即办理
          </div>
          <div v-if="payloading" class="s4s-pay-btn" :style="{backgroundImage:advertisingShow.backgroundImage}">
            立即办理
          </div>
        </div>
  </div>
  <!-- 招行付款form请求 start -->
  <form ref="cmbform" action="https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_APPPay" method="post" >
    <input ref="jsonRequestData" id="jsonRequestData" type="hidden" name="jsonRequestData" v-model="jsonRequestData" />
    <input ref="child" type="hidden" name="charset" value='utf-8' />
  </form>
  <!-- 招行付款form请求 end -->
  <!-- 扫码付款 start -->
  <div class="s4s-mask-pay" @click="closePay" v-if="showpay">
    <p>请扫码付款</p>
    <img :src="paysrc" />
  </div>
    <!-- 扫码付款 end -->
    <a ref="newWebpay"></a>

  <div class="s4s-mask" @click="hideImage" v-if="helpImageSrc">
      <img :src="helpImageSrc" class="s4s-mask-image" />
  </div>
  <div class="s4s-mask-loading" v-if="showMask"></div>

  <!-- 选择省份键盘 start -->
  <Provice :show="showProvice"
  @on-status-change="onProviceStatusChange"
  @on-result-change="onProviceResultChange"  />
  <!-- 选择省份键盘 end -->
  <Pay v-on:confirm="GenerateOrders"
  v-on:cancel="showDialog = false"
  v-on:change="changeType"
  :selected="payType"
  :showDialog="showDialog" :alipay="true" :wechat="showWeixinPay" />
</div>
</template>

<script>
// @ is an alias to /src
import Provice from '@/components/Provice.vue';
import Pay from '@/components/Pay.vue';
import advertisingShow from './../utils/advertising';

export default {
  name: 'createOrder',
  components: {
    Provice,
    Pay,
  },
  data() {
    return {
      showWeixinPay: true,
      // ai 识别返回结果start
      imageUrl: '',
      ticket_image: '',
      noticeNum: '',
      date: '',
      vio_time_image: '',
      fine_image: '',
      price: '',
      carno: '',
      carno_image: '',
      provice: '京',
      name_image: '',
      nick: '',
      // ai 识别返回结果end
      checkData: {},
      phone: '',
      showTicket: false,
      form_warning: false,
      form_error: false,
      orderhead: 'order_head',
      // 扫码
      system: {},
      paysrc: '',
      out_trade_no: '',
      showpay: false,
      timer: null,

      payType: 'alipay',
      showDialog: false,
      nowDate: new Date(),
      code: '',
      carno: '',
      cansend: true,
      QFee: 0,
      tel: '',
      ownFree: 0,
      lateFree: 0,
      ShowLateFree: '0',
      leftTime: 60,
      totalPrice: 0,
      ShowTotalPrice: '0',
      notify: '',
      showDrive: false,
      Quick: 0, // 是否支持加急 0不支持 1 支持
      openQuick: false, // 是否开启加急
      showProvice: false,
      error: '',
      showTicket: false,
      src: '',
      useCoupon: false,
      couponId: 0,
      couponFee: 0,
      couponLen: 0,

      couponPrice: 0,
      couponOwnFree: 0,
      picker: {
        data: this.dataScope('2000-1-1', `${(new Date()).getFullYear()}-${(new Date()).getMonth() + 1}-${(new Date()).getDate() + 1}`),
        type: '',
        anchor: [
          { index: (new Date()).getFullYear() - 2000, value: (new Date()).getFullYear() },
          // { index: (new Date()).getMonth(), value: (new Date()).getMonth() + 1 },
          // { index: (new Date()).getDate() - 2, value: (new Date()).getDate() },
          { index: 0, value: 1 },
          { index: 0, value: 1 },
        ],
        textTitle: '',
        textConfirm: '确认',
        textCancel: '取消',
        swipeTime: 1800,
        colorConfirm: '#3A82FF',
        colorTitle: '',
      },
      helpImageSrc: '',
      XcdNotice: null,
      advertisingShow: advertisingShow(),
      jsonRequestData: '',
      IsReject: 1,
      ticketConfig: '',
      RemindInfo2: [],
      RemindInfo1: '',
      isCarNoRequire: true,
      showMask: false,
      payloading:false,
    };
  },
  activated() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '罚单确认'
      });
    }
    this.payloading = false

    let ticketConfig = this.$store.getters.ticketConfig
    if(ticketConfig){
        this.Quick = !!ticketConfig.IsRejectQuick
        this.ticketConfig = ticketConfig
        this.RemindInfo2 = ticketConfig.RemindInfo2.split('_')
        this.RemindInfo1 = ticketConfig.RemindInfo1
        this.IsReject = ticketConfig.IsReject
    }
    const couponDataCouponId = this.$store.getters.couponId;
    const couponData = this.$store.getters.coupondata;
    if (couponDataCouponId) {
      const couponFee = Number(couponData.Usable.find(item => item.id === couponDataCouponId).CheckReduceFee) || 0;
      let totalPrice = (Number(this.ownFree * 100) || 0) + (Number(this.lateFree * 100) || 0) + (Number(this.price * 100) || 0) - couponFee;
      let ShowTotalPrice = (totalPrice/100).toFixed(2)
      if (this.Quick && this.openQuick) {
        totalPrice = (Number(this.ownFree * 100) || 0) + (Number(this.lateFree * 100) || 0) + (Number(this.price * 100) || 0) + (Number(this.Qfee * 100) || 0) - couponFee;
        ShowTotalPrice = (totalPrice/100).toFixed(2)
      }
      this.couponId = couponDataCouponId,
      this.couponFee = couponFee;
      this.useCoupon = true,
      this.totalPrice = totalPrice;
      this.ShowTotalPrice = ShowTotalPrice;
    } else {
      this.bindPrice();
    }
  },
  watch: {
    noticeNum(value, pre) {
      this.checkTicketFn();
      if(value.substring(0,4) !== pre.substring(0,4)){
        console.log(value,'------1111')
        this.bindPrice();
      }
    },
    date() {
      this.bindPrice();
    },
    carno() {
      this.checkTicketFn();
    },
    nick() {
      this.checkTicketFn();
    },
    phone() {
      this.checkTicketFn();
    },
    price(val) {
      if (val.length > 5) {
        this.price = val.substring(0, 5);
      }
      this.bindPrice();
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  destroyed() {
    console.log('---destroyed');
    this.$store.commit('SET_COUPONDATA', null);
    this.$store.commit('SET_COUPONDID', '');
  },
  methods: {
    getNotice() {
      this.$request('v3/violation/view/notice').then((xhr, res) => {
        if (res.code === 0 && res.data) {
          if (res.data.XcdHave) {
            this.XcdNotice = res.data.XcdNotice;
          }
        } else {
          this.XcdNotice = null;
        }
      }).catch((e) => {
        console.log(e);
        this.XcdNotice = null;
      });
    },
    handleShowNotice() {
      this.$showModal({
        title: this.XcdNotice.Title,
        content: this.XcdNotice.Content,
        confirmText: '我知道了',
      });
    },
    gotoCoupon() {
      this.$router.push({
        path: '/formWrap/couponNow',
      });
    },
    // 查看是否有券
    checkStatus(fee) {
      this.$requestPost('v5/client_coupon/user/check/list', {
        apply: 1, // 对应的业务
        max_amount: fee || this.ownFree * 100,
      }).then((xhr, res) => {
        if (res.code === 0) {
          if (res.data && res.data.Usable && res.data.Usable.length) {
            this.couponLen = res.data.Usable.length;
          }
          this.$store.commit('SET_COUPONDATA', res.data);
        }
      });
    },
    feeQues() {
      this.$showModal({
        title: '2小时加急处理',
        content: '1. 勾选“2小时加急”选项，我们将在2小时内缴纳罚款至银行。\n 2. 未勾选“2小时加急”选项，我们将在24小时内缴纳罚款至银行。',
        confirmText: '我知道了',
      });
    },
    ownFreeModal() {
      this.$showModal({
        title: '服务费用',
        content: '齐车大圣属于第三方代办平台，为您跑腿代办车管所业务将会收取相应的服务费，感谢您的理解',
        confirmText: '我知道了',
      });
    },
    changeType(val) {
      this.payType = val;
    },
    confirmFn() {

    },
    onProviceStatusChange(val) {
      this.showProvice = val;
    },
    onProviceResultChange(val) {
      this.provice = val;
    },
    // time
    handlePickerCancel() {},
    handlePickerConfirm(e) {
      this.date = `${e[0].value}-${e[1].value}-${e[2].value}`;
    },
    dataScope(value1, value2) {
      const getDate = (str) => {
        const tempDate = new Date();
        const list = str.split('-');
        tempDate.setFullYear(list[0]);
        tempDate.setMonth(list[1] - 1);
        tempDate.setDate(list[2]);
        return tempDate;
      };
      let date1 = getDate(value1);
      let date2 = getDate(value2);
      if (date1 > date2) {
        const tempDate = date1;
        date1 = date2;
        date2 = tempDate;
      }
      date1.setDate(date1.getDate());
      const dateArr = [];
      // const i = 0;
      let year = 0;
      let month = 0;
      while (
        !(
          date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()
        )
      ) {
        let dayStr = date1.getDate().toString();
        if (dayStr.length === 1) {
          dayStr = `0${dayStr}`;
        }
        if (!dateArr[year]) {
          dateArr[year] = {
            value: '',
            children: [],
          };
        }
        if (!dateArr[year].children[month]) {
          dateArr[year].children[month] = {
            value: '',
            children: [],
          };
        }
        // 应该改为 push 方式
        dateArr[year].value = date1.getFullYear();

        dateArr[year].children[month].value = date1.getMonth() + 1;
        if (dateArr[year].children[month].value.toString().length === 1) {
          dateArr[year].children[month].value = `0${dateArr[year].children[month].value}`;
        }
        dateArr[year].children[month].children.push({
          value: dayStr,
        });

        // 增加年 置空月
        if (Number(date1.getMonth()) + 1 === 12 && Number(dayStr) === 31) {
          year += 1;
          month = 0;
        }

        const nowMonth = date1.getMonth() + 1;
        date1.setDate(date1.getDate() + 1);
        // 增加月
        if (date1.getMonth() + 1 > nowMonth) {
          month += 1;
        }
      }
      return dateArr;
    },
    chooseImage(type) {
      this.chooseType = type;
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    // 上传
    uploader() {
      const list = this.$refs.file.files;
      const item = {
        name: list[0].name,
        size: list[0].size,
        file: list[0],
      };
      this.html5Reader(list[0], item);
    },
    html5Reader(file, item) {
      const imgSrc = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        imgSrc.src = e.srcElement.result;
        this.$set(item, 'src', e.srcElement.result);
        const self = this;
        imgSrc.onload = function () {//eslint-disable-line
          // 图片原始尺寸
          const originWidth = this.width;
          const originHeight = this.height;
          // 最大尺寸限制
          const maxWidth = 2000;
          const maxHeight = 2000;
          // 目标尺寸
          let targetWidth = originWidth;
          let targetHeight = originHeight;
          // 图片尺寸超过400x400的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              // 更宽，按照宽度限定尺寸
              targetWidth = maxWidth;
              targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
          }
          const canvas = document.getElementById('canvas');
          const context = canvas.getContext('2d');
          // canvas对图片进行缩放
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 清除画布
          context.clearRect(0, 0, targetWidth, targetHeight);
          // 图片压缩
          context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
          const data = canvas.toDataURL('image/jpeg').split(',')[1];
          // 获取base64图片大小，返回MB数字
          const size = parseInt(data.length - (data.length / 4), 10);
          if (size) {
            const isLt2M = size / 1024 / 1024 < 2;
            if (!isLt2M) {
              self.$showToast({ title: '图片大小需要小于 2MB!' });
              return;
            }
            self.$showToast({ title: '正在上传...' });
            self.showMask = true
            self.handleAi(data);
            document.getElementById('file').value = ''; // 把input值置空，要不上传同一种图片change方法不生效
            // self.$requestPost('v3/violation/image/upload', {
            //   imageString: data,
            // }).then((xhr, res) => {
            //   if (res.code === 0) {
            //     self.$showToast({ title: '上传成功' });
            //     if (self.chooseType === 'ticket') {
            //       self.imageUrl = res.data;
            //     } else if (self.chooseType === 'JSZTravel') {
            //       self.JSZTravelUrl = res.data;
            //     } else if (self.chooseType === 'JSZDrive') {
            //       self.JSZDriveUrl = res.data;
            //     } else if (self.chooseType === 'travelUrl') {
            //       self.travelUrl = res.data;
            //     } else if (self.chooseType === 'driveUrl') {
            //       self.driveUrl = res.data;
            //     }
            //   } else {
            //     self.$showToast({ title: res.msg });
            //   }
            // });
          }
        };
      };
      reader.readAsDataURL(file);
    },
    // ai 识别罚单
    handleAi(data) {
      const that = this;
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/ticket',
            // noticeNum: this.noticeNum,
          },
        });
        this.$hideToast();
        this.showMask = false;
        return;
      }
      // this.$store.getters.AiTicketList
      // this.$store.commit('SET_AITICKETLIST', res.data);
      // this.$showToast({
      //   title: '正在上传'
      // })
      this.$requestPost('v3/violation/recognition', {
        imageString: data,
      }).then((xhr, res) => {
        this.showMask = false
        // setTimeout(()=> {
        //   this.$hideToast();
        // }, 5);
        if (res.code === 0) {
          if (res.data && res.data[0]) {
            const successList = res.data;
            this.$store.commit('SET_AITICKETLIST', res.data);
            // this.formatList(successList[0]);
            this.queryTicketInfo(successList[0])
          } else {
            this.formatList({});
            this.$showToast({ title: '对不起，未识别出处罚决定书信息' });
            this.$store.commit('SET_AITICKETLIST', []);
          }
        } else {
          this.formatList({});
          this.$showToast({ title: res.msg || '对不起，请重新选择处罚决定书照片' });
        }
      }).catch((e) => {
        this.$showToast({ title: '上传失败，请重新上传处罚决定书照片' });
        this.$hideToast();
      });
    },

    formatList(list) {
      this.imageUrl = list.imageUrl || '';
      this.ticket_image = list.ticket_image || '';
      this.noticeNum = list.ticket || '';
      this.vio_time_image = list.vio_time_image || '';
      this.date = list.vio_time || '';
      this.fine_image = list.fine_image || '';
      this.price = list.fine || 0;
      this.provice = list.carno && list.carno.substring(0, 1) || '京';
      this.carno = list.carno && list.carno.substring(1) || '';
      this.carno_image = list.carno_image || '';
      this.name_image = list.name_image || '';
      this.nick = list.name || '';
      if (this.userInfo && this.userInfo.Tel) {
        this.phone = this.userInfo.Tel && this.userInfo.Tel.substring(0, 11);
      }
      console.log('---------------formatList')
      this.bindPrice();
      this.checkTicketFn();
    },
    checkTicketFn() {
      const checkData = {
        checked: true,
        msg: '',
      };
      this.error = '';
      const telReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      const ticketReg = /(^\d{15}$)| (^\d{16}$)| (^\d{14}(\d|X|x)$)|(^\d{15}(\d|X|x)$)/;
      // 最后一位可以为 x

      if (!ticketReg.test(this.noticeNum)) {
        checkData.checked = false;
        checkData.msg = '罚单编号不正确';
        checkData.ticket = {
          key: 'ticket',
          value: this.noticeNum,
          msg: '罚单编号不正确',
        };
      }
      if (this.date === '') {
        checkData.checked = false;
        if (!checkData.msg) checkData.msg = '认罚日期不正确';
        checkData.date = {
          key: 'date',
          value: this.date,
          msg: '认罚日期不正确',
        };
      }
      if (Number(this.price) < 20) {
        checkData.checked = false;
        if (!checkData.msg) checkData.msg = '罚款金额需大于20元';
        checkData.price = {
          key: 'price',
          value: this.price,
          msg: '罚款金额需大于20元',
        };
      }
      // if (this.isCarNoRequire && this.carno.length !== 6 && this.carno.length !== 7) {
      //   checkData.checked = false;
      //   if (this.isCarNoRequire && !checkData.msg) checkData.msg = '车牌号码不正确';
      //   checkData.carno = {
      //     key: 'carno',
      //     value: this.carno,
      //     msg: '车牌号码不正确',
      //   };
      // }
      if (this.nick === '') {
        checkData.checked = false;
        if (!checkData.msg) checkData.msg = '请输入姓名';
        checkData.nick = {
          key: 'nick',
          value: this.nick,
          msg: '请输入姓名',
        };
      }
      // const reg = /^([\u4e00-\u9fa5]){2,7}$/;
      // if (!reg.test(this.nick)) {
      //   checkData.checked = false;
      //   if (!checkData.msg) checkData.msg = '请输入中文姓名';
      //   checkData.nick = {
      //     key: 'nick',
      //     value: this.nick,
      //     msg: '请输入中文姓名',
      //   };
      // }
      if (!telReg.test(this.phone)) {
        checkData.checked = false;
        if (!checkData.msg) checkData.msg = '手机号码不正确';
        checkData.phone = {
          key: 'phone',
          value: this.phone,
          msg: '手机号码不正确',
        };
      }
      if ((this.noticeNum !== '' && checkData.ticket) || (this.date !== '' && checkData.date)
        || (this.price !== '' && checkData.price) || (this.carno !== '' && checkData.carno)
        || (this.nick !== '' && checkData.nick) || (this.phone !== '' && checkData.phone)) {
        this.form_error = true;
        this.form_warning = false;
        this.orderhead = 'order-head errorbg';
      } else if (this.noticeNum == '' || this.date == '' || this.price == '' || this.carno == '' || this.nick == '' || this.phone == '') {
        this.form_warning = true;
        this.form_error = false;
        this.orderhead = 'order-head waringbg';
      } else {
        this.form_error = false;
        this.form_warning = false;
        this.orderhead = 'order-head';
      }
      this.checkData = checkData;
    },
    // 立即办理
    formSubmit() {
      if(this.IsReject !== 1){
        this.$showModal({
          title: '温馨提示',
          content: '该城市暂时不支持办理，敬请期待',
          confirmText: '我知道了',
        });
        return
      }
      if (this.checkData.checked) { // form表单验证通过
        if (this.payType === 'cmbchina2') {
          this.GenerateOrders();
        } else if (this.payType === 'abchina') {
          this.GenerateOrders();
        } else if (this.payType === 'unionpay') {
          this.GenerateOrders();
        } else {
          this.showDialog = true;
        }
      } else {
        this.$showToast({
          title: `信息尚未完善,${this.checkData.msg}`,
        });
      }
    },
    // 罚款金额
    bindPrice() {
      if (!this.date) {
        this.totalPrice = (Number(this.ownFree) * 100 || 0) + (Number(this.lateFree * 100) || 0) + (Number(this.price * 100) || 0) - (this.useCoupon ? this.couponFee : 0);
        this.ShowTotalPrice = (((Number(this.ownFree) * 100 || 0) + (Number(this.lateFree * 100) || 0) + (Number(this.price * 100) || 0) - (this.useCoupon ? this.couponFee : 0)) / 100).toFixed(2);
        return;
      }
      const param = {
        notice_num: this.noticeNum,
        fine: Number(this.price) * 100,
        vio_time: this.date.substr(0, 10),
      };
      if (this.useCoupon) {
        param.coupon_id = this.couponId;
      }
      this.$request('v3/violation/fee', param).then((xhr, res) => {
        if (res.code === 0) {
          this.checkStatus(res.data.OwnFree);
          this.totalPrice = (Number(res.data.OwnFree) || 0) + (Number(res.data.LateFree) || 0) + (Number(this.price * 100) || 0) - (this.useCoupon ? this.couponFee : 0);
          this.ShowTotalPrice = (((Number(res.data.OwnFree) || 0) + (Number(res.data.LateFree) || 0) + (Number(this.price * 100) || 0) - (this.useCoupon ? this.couponFee : 0)) / 100).toFixed(2);
          // if (this.Quick && this.openQuick) {
          //   totalPrice = ((Number(res.data.OwnFree) * 0.01 || 0) +
          //   (Number(res.data.LateFree) * 0.01 || 0) + (Number(this.price) || 0) +
          //   (Number(res.data.Qfee) * 0.01 || 0));
          // }
          this.ownFree = (Number(res.data.OwnFree) * 0.01 || 0);
          this.lateFree = res.data.LateFree;
          this.ShowLateFree = (Number(res.data.LateFree) * 0.01 || 0).toFixed(2);
          this.QFee = (Number(res.data.Qfee) * 0.01 || 0);
          // this.totalPrice = totalPrice;
          this.Quick = res.data.Config ? !!res.data.Config.IsRejectQuick : true;
          this.openQuick = (res.data.Config && res.data.Config.IsRejectQuick) === 0 ? false : this.openQuick;
          this.couponOwnFree = (Number(res.data.OwnFree) * 0.01 || 0) + Number(this.couponPrice);
          this.ticketConfig = res.data.Config;
          this.RemindInfo2 = res.data.Config ? res.data.Config.RemindInfo2.split('_') : [];
          this.RemindInfo1 = res.data.Config ? res.data.Config.RemindInfo1 : '';
          this.IsReject = res.data.Config ? res.data.Config.IsReject : 1;
          // this.attentionTime = (res.data.Config && res.data.Config.IsRejectQuick) === 0 ?'24小时内': this.data.attentionTime,

        } else {
          this.checkStatus(0);
          this.$showToast({
            title: res.msg,
          });
          this.ownFree = 0;
          this.lateFree = 0;
          this.QFee = 0;
          this.Quick = false;
        }
      }).catch((e) => {
        console.log(e, 'priceeeeee');
        this.checkStatus(0);
      });
      this.checkTicketFn();
    },
    signFigures(num, rank = 6) {
      if (!num) return (0);
      const sign = num / Math.abs(num);
      const number = num * sign;
      const temp = rank - 1 - Math.floor(Math.log10(number));
      let ans;
      if (temp > 0) {
        ans = parseFloat(number.toFixed(temp));
      } else if (temp < 0) {
        ans = Math.round(number / Math.pow(10, temp)) * temp;
      } else {
        ans = Math.round(number);
      }
      return (ans * sign);
    },
    // 提交订单
    GenerateOrders() {
      this.payloading = true;
      this.showDialog = false;
      const self = this;
      const price = Number(this.price * 100);
      const param = {
        fine: price, // 罚金
        ownFree: this.ownFree * 100, // 服务费用
        lateFree: this.lateFree, // 滞纳金
        totalPrice: this.totalPrice, // 总金额
        notice_num: this.noticeNum, // 文书号
        vio_time: this.date.substr(0, 10), // 文章时间：格式：2017-12-13
        img_url: this.imageUrl || '', // 罚单连接
        carno: this.provice + this.carno.toUpperCase(),
        mobile: this.phone,
        name: this.nick, // 罚款人
        using_ai: 1,
      };
      if (this.openQuick && this.Quick) {
        param.qfee = this.QFee * 100; // 加急费+ this.QFee * 100
        param.urge = 1;
        // param.totalPrice = (this.totalPrice * 100) + (this.QFee * 100);
        param.totalPrice = this.totalPrice + (this.QFee * 100);
      }
      if (this.useCoupon) {
        param.coupon_id = this.couponId;
      }
      if (this.payType === 'wechat_web') {
        param.pay_method = 'wechat_web';
        param.client_ip = '';
        const city = window.returnCitySN;
        if (city) {
          param.client_ip = city.cip;
        }
        const ua = navigator.userAgent.toLowerCase();
        // if (!self.system.win && !self.system.mac && !self.system.xll) {
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
          param.pay_method = 'wechat_app';
        } else {
          param.pay_method = 'wechat_h5';
        }
        // }
      } else if (this.payType === 'abchina') {
        param.pay_method = 'abchina';
        console.log('--------n行支付');
        this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
          this.payloading = false;
          if (res.code > 0) {
            this.$showToast({ title: res.msg });
            return;
          }
          if (res.data && res.data.qr_code) {
            if(window.navigator.userAgent.indexOf('Bankabc/Portal') != -1) {//1. 判断是否在n行app新容器
              let qr_code = res.data.qr_code.replace('|','*')
              qr_code = qr_code.split('*')
              let tokenId = qr_code[1]
              let webviewURL = qr_code[2]
              AlipayJSBridge.call('startApp',{
                appId: '30603024', // 固定值
                param:{
                  type: "3", //   3： zy内H5页面，
                  tokenId: tokenId,  //商户传过来的tokenId
                  paySystem: "",       //商户传过来的paySystem, 没有则传空字符串
                  payType: "1111",         //商户传过来的payType，没有则传'1111'
                  webviewURL: webviewURL,      //商户传过来的回跳地址
                  startMultApp: 'YES', // 同一个H5容器如果需要多次调起快E付
                  showProgress: 'NO',
                  backBehavior: 'back'
                },
              },function(result){
              });
            }else{
              window.location.href = res.data.qr_code;
            }
          }
        });
        return;
      } else if (this.payType === 'unionpay') {
        param.pay_method = 'unionpay';
        this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
          this.payloading = false;
          if (res.code > 0) {
            this.$showToast({ title: res.msg });
            return;
          }
          if (res.data && res.data.tn) {
            upsdk.pay({
              tn: res.data.tn,
              success: () => {
                window.location.href = "https://mys4s.cn/static/vio/index.html#/ticket?channel=unionpay"
              },
              fail: (e) => {
              }
            })
          }
        });
        return;
      } else if (this.payType === 'cmbchina2') {
        // window.location.href = `https://mys4s.cn/grey/v3/violation/web/order/create?pay_method=cmbchina2&fine=${param.fine
        // }&ownFree=${param.ownFree}&lateFree=${param.lateFree}&totalPrice=${param.totalPrice
        // }&notice_num=${param.notice_num}&vio_time=${param.vio_time}&img_url=${param.img_url
        // }&carno=${param.carno}&mobile=${param.mobile}&name=${param.name}&drive_no=${param.drive_no
        // }&qfee=${param.qfee}&urge=${param.urge}&access_token=${this.access_token}&channel=${this.channel}&t=${this.t}`;
        const cmbform = this.$refs.cmbform;
        param.pay_method = 'cmbchina2';
        this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
          if (res.code === 0) {
            const form = document.createElement('form');
            const input = document.createElement('input');
            const input2 = document.createElement('input');
            input2.setAttribute('name', 'charset');
            input2.setAttribute('type', 'hidden');
            input.setAttribute('type', 'hidden');
            input2.setAttribute('value', 'utf-8');
            input.setAttribute('name', 'jsonRequestData');
            // try {
            //   const data = JSON.parse(res.data)
            //   console.log(data)
            //   input.setAttribute('value', data);
            // } catch (e) {
            //   console.log('parseerr', e)
            // }
            input.setAttribute('value', res.data);

            form.appendChild(input);
            form.appendChild(input2);
            form.setAttribute('action', 'https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_APPPay');
            form.setAttribute('method', 'post');
            // this.jsonRequestData = res.data;
            document.querySelector('body').appendChild(form);
            form.submit();
          }
          // if(res.code === 0){
          //   document.getElementById('jsonRequestData').value = res.data;
          //   cmbform.submit();
          // }
        });
        return;
      }
      this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
        if (res.code === 20022) {
          self.$router.push({
            path: '/login',
            query: {
              redirect: '/createOrder',
            },
          });
          return;
        }
        if (res.code >= 40000 && res.code < 50000) {
          self.$router.push({
            path: '/login',
            query: {
              redirect: '/createOrder',
            },
          });
          return;
        }
        if (res.code === 0) {
          // console.log(this.system.win || this.system.mac || this.system.xll);
          if (this.system.win || this.system.mac || this.system.xll) { // 如果是电脑跳转到
            self.paysrc = this.payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img;
            self.out_trade_no = res.data.out_trade_no;
            self.showpay = true;
            self.timer = setInterval(self.getPayStatus, 1000);
            return;
          }
          if (self.payType === 'wechat_web') {
            // window.location.href = res.data.MwebUrl
            const ua = navigator.userAgent.toLowerCase();
            const { data } = res;
            if (ua.match(/MicroMessenger/i) === 'micromessenger') {
              if (typeof WeixinJSBridge === 'undefined') {
                this.$showToast({ title: '支付失败,请稍后再试' });
              } else {
                WeixinJSBridge.invoke(//eslint-disable-line
                  'getBrandWCPayRequest', {
                    appId: data.appId, // 公众号名称，由商户传入
                    timeStamp: data.timeStamp || data.timestamp, // 时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, // 随机串
                    package: data.package,
                    signType: data.signType, // 微信签名方式：
                    paySign: data.paySign, // 微信签名
                  },
                  (ress) => {
                    if (ress.err_msg === 'get_brand_wcpay_request:ok') {
                      self.$router.replace({
                        path: '/success2',
                        query: {
                          price: this.ShowTotalPrice,
                        },
                      });
                    }
                  },
                );
              }
            } else if (res.data && res.data.MwebUrl) {
              self.$refs.newWebpay.href = res.data.MwebUrl;
              // self.MwebUrl = res.data.MwebUrl
              self.$refs.newWebpay.click();
            }
          } else {
            window.location.href = res.data.qr_code;
          }
        } else {
          this.$showToast({ title: res.msg });
        }
      });
    },
    closePay() {
      this.showpay = false;
      clearInterval(this.timer);
    },
    getPayStatus() {
      const self = this;
      this.$request('/v3/violation/order/poll', {
        order_id: this.out_trade_no,
      }).then((xhr, res) => {
        if (res.code === 0 && res.data === 1) {
          self.showpay = false;
          clearInterval(self.timer);
          self.$router.push({
            path: '/success',
          });
        }
      });
    },
    // 关闭蒙层
    hideImage() {
      this.helpImageSrc = '';
    },
    // 发动机详情
    showImage(src) {
      this.helpImageSrc = src;
    },
    handleCheckTicket() {
      this.showTicket = true;
    },
    handleHideTicket(e) {
      this.showTicket = false;
    },
    queryTicketInfo(param) {// 识别出全部字段则填写不进行罚单编号查询
      if(param.ticket && param.imageUrl && param.vio_time && param.fine && param.carno && param.name){
        this.formatList(param);
        this.bindPrice();
        return
      }
      this.showMask = true
      this.$showToast({
        title: '正在识别...',
        duration: '4000',
      })
      // my.showLoading({
      //   content: '正在识别',
      // })
      this.imageUrl = param.imageUrl || '';
      this.noticeNum = param.ticket || '';
      this.$requestPost('v3/violation/notice_num/query', {write_notice_num: param.ticket}).then((xhr, res) => {
        this.showMask = false
        this.$hideToast()
        if (res.code == 0) {
            this.ticket_image = '';
            this.vio_time_image = '';
            this.fine_image = '';
            this.carno_image ='';
            this.name_image = '';

            this.date = res.data.btr_time || param.vio_time;
            this.price = Number(res.data.fine/100 || param.fine || 0);
            this.provice = this.checkCarNo(res.data.car_no) ? res.data.car_no.substring(0,1) : param.carno.substring(0,1);
            this.carno = this.checkCarNo(res.data.car_no) ?  res.data.car_no.substring(1) : param.carno.substring(1);
            this.nick = res.data.fine_name || param.name;
            this.isCarNoRequire = this.checkCarNo(res.data.car_no || param.carno)
            if (this.userInfo && this.userInfo.Tel) {
              this.phone = this.userInfo.Tel && this.userInfo.Tel.substring(0, 11);
            }
            this.bindPrice();
            this.checkTicketFn();
        }else{
          this.formatList(param);
          this.bindPrice();
        }
      }).catch( () => {
        this.showMask = false
        this.formatList(param);
        this.$$hideToast()
      })
  },
  checkCarNo(carno){
    let carnoReg
    if (carno.length == 7) {
      carnoReg = /(^[\u4e00-\u9fa5]{1}[a-zA-Z]{1}[a-zA-Z0-9]{4}[a-zA-Z0-9挂学警港澳]{1})/
    } else {
      carnoReg = /(^[\u4e00-\u9fa5]{1}[a-zA-Z]{1}[a-zA-Z0-9]{6})/
    }
    return carnoReg.test(carno)
  },
  },
  mounted() {
    const nowChannel = this.advertisingShow.channel;
    const notShowWeixinPay = ['xcarillegal', 'xcarticket']; //   这个数组里的channel 不展示  微信支付
    if (notShowWeixinPay.indexOf(nowChannel) !== -1) {
      this.showWeixinPay = false;
    }
    const AiTicketList = this.$store.getters.AiTicketList[0];
    if (AiTicketList) {
      this.imageUrl = AiTicketList.imageUrl || '';
      this.noticeNum = AiTicketList.ticket || '';
      // this.formatList(AiTicketList);
      // this.bindPrice();
      this.queryTicketInfo(AiTicketList)
      let ticketConfig = this.$store.getters.ticketConfig
      if(ticketConfig && ticketConfig.DialogContent){
        this.$showModal({
          title: '温馨提示',
          content: ticketConfig.DialogContent,
          confirmText: '我知道了',
        });
      }
    }
    if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
      this.payType = 'cmbchina2';
      this.access_token = this.$store.getters.token;
      this.channel = window.localStorage.viochannel;
      this.t = (new Date()).getTime();
    }else if (this.advertisingShow.channel === 'abchina' || window.localStorage.getItem('viochannel') === 'abchina') {
      this.payType = 'abchina';
      // let noticeNum =  AiTicketList && AiTicketList.ticket
      // let str1 = noticeNum.substring(0,4)
      // let str2 = noticeNum.substring(0,2)
      // if(noticeNum && (str1 == '3702' || str2 == '51' || str2 == '62')){
      //   this.ownFreeModal()
      // }
    }
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      this.payType = 'unionpay';
    }
    // const p = navigator.platform;
    // this.system.win = p.indexOf('Win') >= 0;
    // this.system.mac = p.indexOf('Mac') >= 0;
    // this.system.x11 = (p === 'X11') || (p.indexOf('Linux') >= 0);
    this.system.win = false;
    this.system.mac = false;
    this.system.x11 = false;

    this.getNotice();
  },
};
</script>
<style lang="scss" scoped>
.s4s-page {
  padding-bottom: 70px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  line-height: 1;
}

.weui-switch {
  display: inline-block;
  position: relative;
  width: 52px;
  height: 32px;
  border: 1px solid #dfdfdf;
  outline: 0;
  border-radius: 16px;
  box-sizing: border-box;
  background-color: #dfdfdf;
  transition: background-color 0.1s, border 0.1s;
  cursor: pointer;
}
.weui-switch:before {
  content: " "!important;
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 30px;
  border-radius: 15px;
  background-color: #fdfdfd;
  transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
}
.weui-switch:after {
  content: " "!important;
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
}
.weui-switch-on {
  border-color: #1aad19;
  background-color: #1aad19;
}
.weui-switch-on:before {
  border-color: #1aad19;
  background-color: #1aad19;
}
.weui-switch-on:after {
  transform: translateX(20px);
}
.s4s-group.group-image {
  padding: 12px 0;
  justify-content: space-between;
}
.order-image-ticket {
  width: 120px;
  height: 80px;
  border-radius: 4px;
}
.s4s-group-txt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  text-align: right;
}
.s4s-group-txt input{
  text-align: right;
}
.order-image-other {
  height: 28px;
  // width: 100%;
  background-position: right!important;
}
.write-tip{
  font-size: 12px;
  color: #9C9EA8;
  height: 27px;
  background:#F7F7F8;
  text-align: center;
  line-height:27px;
  border-radius: 4px;
}
.ticket-container {
  transition: transform 500ms ease;
  position: absolute;
  transform: scale(0);
}
.ticket-container-show {
  position: fixed;
  transform: scale(1);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 999;
  /* overflow: scroll; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ticket-container-image {
  width: 100%;
}
.ticket-btn-container {
  position: absolute;
  bottom: 60px;
  display: flex;
  justify-content: space-around;
  width: 70%;
  -webkit-text-stroke: 1px #9C9EA8;
}
.ticket-btn{
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
}

.ticket-btn-reupload {
  width: 68px;
  margin-bottom: 10px;
}
.order-head{
  height: 44px;
  background: #E6FBF3;
  color: #5B5E6A;
  font-size: 14px;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  align-items: center
}
.order-waring {
  width: 18px;
  margin: 0 0 0 8px;
}
.yellow{
  color: #FFA71D;
}
.waringbg{
  background: #FFF1DB;
}
.errorbg{
  background: #FFEAE6;
}
.s4s-right-arr {
  height: 14px;
  width: 7px;
  margin-left: 10.5px;
}
.justify-content-between {
  justify-content: space-between;
}
</style>

